{
	"altLogo": "Logo",
	"criticalError": "Pixieset Photo Editor has encountered a critical error while processing photos.",
	"pleaseReload": "Please reload the page to continue.",
	"reload": "Reload"
}
